var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileOutline = function SvgFileOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.001 1.246H4.753a3.75 3.75 0 0 0-3.75 3.75v29.996a3.75 3.75 0 0 0 3.75 3.75h22.498a3.75 3.75 0 0 0 3.75-3.75V13M19 1.246l12 11.754M19 1.246V11a2 2 0 0 0 2 2h10"
  })));
};
export default SvgFileOutline;